import { orgManagementClient } from '../../api/clients';
import deleteOrganization from './delete-organization/delete-organization';

const settingsService = {
  deleteOrganization: deleteOrganization(orgManagementClient),
};

export default settingsService;
